<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">车辆信息</div>
      <div class="box">
        <div class="form">
          <el-form ref="form" :model="form" :rules="rules" label-width="160px">
            <div class="step">第一步</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="车架号" prop="frame_num">
                  <el-input
                    v-model="form.frame_num"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产日期" prop="product_time">
                  <template v-if="edit">
                    <el-date-picker
                      v-model="form.product_time"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                      @change="productDateChange"
                    >
                    </el-date-picker>
                  </template>
                  <template v-else>
                    <span class="value">
                      {{ form.product_time }}
                    </span>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="车工号" prop="work_num">
                  <el-input
                    v-model="form.work_num"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="维护时间" prop="maintenance_time">
                  <el-date-picker
                    v-model="form.maintenance_time"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="step">第二步</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="车辆品牌" prop="brand">
                  <el-select
                    v-model="form.brand"
                    @change="brandChange"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.brand"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车型" prop="model">
                  <el-select
                    v-model="form.model"
                    @change="modelChange"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.carModelOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="车辆型号" prop="type">
                  <el-select
                    v-model="form.type"
                    @change="typeChange"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.carTypeOptions"
                      :key="item.id"
                      :label="item.type"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="底盘型号">
                  <template v-if="edit">
                    <el-input
                      v-model="form.chassis"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                  <template v-else>
                    <span class="value">
                      {{ form.chassis }}
                    </span>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="step">第三步</div>
            <template>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车牌号">
                    <el-input
                      v-model="form.license_num"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="TBox编号">
                    <el-input
                      v-model="form.tbox_num"
                      @focus.stop="dialogVisible = true"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item> -->
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头信息">
                    <template v-if="edit">
                      <el-input
                        v-model="form.camera"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">
                        {{ form.camera }}
                      </span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <!-- <template v-else>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车牌号" prop="license_num">
                    <el-input
                      v-model="form.license_num"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头信息">
                    <template v-if="edit">
                      <el-input
                        v-model="form.camera"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">
                        {{ form.camera }}
                      </span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
            </template> -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="所属公司" prop="belong_company">
                  <template>
                    <el-select
                      v-model="form.belong_company"
                      filterable
                      placeholder="请选择"
                      style="width: 100%"
                      @change="companyChange"
                    >
                      <el-option
                        v-for="item in options.belongCompDataOptions"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="配置">
                  <template v-if="edit">
                    <el-select
                      v-model="form.configuration"
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in options.configOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <el-select
                      v-model="form.configuration"
                      disabled
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in options.configuration"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子说明书">
                  <a :href="form.e_instruction" target="_blank">{{
                    form.e_instruction ? '说明书' : ''
                  }}</a>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="TBox编号" prop="tbox_num">
                  <el-input
                    v-model="form.tbox_num"
                    @focus.stop="dialogVisible = true"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col
                :span="12"
                v-for="(item, index) in serviceList"
                :key="index"
              >
                <el-form-item :label="item.name">
                  <el-input
                    clearable
                    @clear="clearHardware(index)"
                    :value="item.code"
                    @focus.stop="showHardwareDialog(item.id, item.code)"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="车型图片">
                  <img v-if="form.typeImg" :src="form.typeImg" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btns">
            <el-button
              type="primary"
              :disabled="disabled"
              @click="submitForm('form')"
              >保存信息</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <popup
      v-if="dialogVisible"
      @parent="childHanel"
      :companyId="form.belong_company"
    />
    <HardwareList
      :visible="hardwareDialogVisible"
      @visible-change="modalVisibleChange"
      :serviceTypeId="serviceTypeId"
      @success="getHardwareCode"
      :preHardwareCode="preHardwareCode"
    />
  </div>
</template>

<script>
import { addCarInform, GetdataSelectCarUser } from '@/api/car';
import { getAllServiceTypeList } from '@/api/serviceType';
import { getToken } from '@/utils/auth';
import {
  GetDataSelectXing,
  GetdataSelectType,
  queryCarTypeData,
} from '@/api/system';
import { selectCompanyData } from '@/api/company';
import popup from './popup';
import HardwareList from './hardwareList';

export default {
  components: { popup, HardwareList },
  data() {
    return {
      dialogVisible: false,
      hardwareDialogVisible: false, // 硬件列表弹窗
      token: getToken(),
      disabled: false,
      edit: true,
      user_id: '',
      data: {
        type: '',
      },
      form: {
        photo: '',
        type: '',
        rent_company: null,
        belong_company: null,
        brand: '',
        tbox_num: '',
      },
      options: {
        brand: [],
        type: [],
        user: [],
        belongCompDataOptions: [],
        rentCompDataOptions: [],
        carModelOptions: [],
        carTypeOptions: [],
        configOptions: [
          { id: '豪华', name: '豪华' },
          { id: '高配', name: '高配' },
          { id: '低配', name: '低配' },
        ],
      },
      rules: {
        frame_num: [
          { required: true, message: '请输入车架号', trigger: 'blur' },
          {
            min: 17,
            max: 17,
            message: '车架号固定长为17位！',
            trigger: 'blur',
          },
        ],
        product_time: [
          { required: true, message: '请选择生产日期', trigger: 'blur' },
        ],
        work_num: [
          { required: true, message: '请输入车工号', trigger: 'blur' },
          // { min: 14, max: 14, message: '车工号固定长为14位！', trigger: 'blur' }
        ],
        maintenance_time: [
          { required: true, message: '请选择维护时间', trigger: 'blur' },
        ],
        type: [{ required: true, message: '请输入车辆型号', trigger: 'blur' }],
        brand: [{ required: true, message: '请输入车辆品牌', trigger: 'blur' }],
        model: [{ required: true, message: '请输入车型', trigger: 'blur' }],
        belong_company: [
          { required: true, message: '请选择所属公司', trigger: 'blur' },
        ],
        rent_company: [
          { required: false, message: '请选择租聘或个人', trigger: 'blur' },
        ],
        license_num: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ],
        tbox_num: [{ required: true, message: '请选择tobx', trigger: 'blur' }],
      },
      belongCompData: [],
      rentCompData: [],
      receiveCompData: [],
      brandModelData: [],
      modelTypeData: [],
      serviceList: [],
      serviceTypeId: null, // 当前服务分类
      preHardwareCode: null,
    };
  },
  created() {
    this.GetSelect();
    this.initCompanyData();
  },

  methods: {
    //清除
    clearHardware(index) {
      const serviceList = [...this.serviceList];
      serviceList[index].code = '';
      this.serviceList = serviceList;
    },
    // 显示弹窗
    showHardwareDialog(id, code) {
      this.preHardwareCode = code || '';
      this.hardwareDialogVisible = true;
      this.serviceTypeId = id;
    },
    modalVisibleChange(val) {
      this.hardwareDialogVisible = val;
    },
    productDateChange() {
      let arr = this.form.product_time.split('-');
      this.$set(
        this.form,
        'maintenance_time',
        parseInt(arr[0]) + 1 + '-' + arr[1] + '-' + arr[2]
      );
    },
    //
    getDataSelectXing() {
      GetDataSelectXing({ companyId: this.form.belong_company }).then((res) => {
        this.options.brand = res.data.content;
      });
    },
    getCarTypeData() {
      queryCarTypeData({ companyId: this.form.belong_company }).then((res) => {
        this.brandModelData = res.data.brandModel;
        this.modelTypeData = res.data.modelType;
      });
    },
    companyChange() {
      this.form.brand = '';
      this.form.model = '';
      this.form.type = '';
      this.getDataSelectXing();
      this.getCarTypeData();
    },
    GetSelect() {
      GetdataSelectType().then((res) => {
        this.options.type = res.data.content;
      });
      //  GetdataSelectCar().then(res=>{
      //   this.options.model =  res.data.content
      // })
      GetdataSelectCarUser().then((res) => {
        this.options.user = res.data.content;
      });
      this.getServiceTypeList();
    },

    async getServiceTypeList() {
      const { data } = await getAllServiceTypeList();
      const serviceTypeList = data; // 服务类型
      this.serviceList = serviceTypeList.map((item) => {
        return {
          ...item,
          code: '', // 对应选择的硬件code
        };
      });
    },

    //车辆品牌选中事件
    brandChange() {
      let brand = this.form.brand;
      if (brand != null && brand != '') {
        this.options.carModelOptions = [];
        this.form.model = null;
        this.options.carTypeOptions = [];
        this.form.type = null;
        this.brandModelData.forEach((el) => {
          if (el.brand === brand) {
            this.options.carModelOptions.push(el);
          }
        });
      }
    },
    //车型选中事件
    modelChange() {
      let model = this.form.model;
      let brand = this.form.brand;
      if (model != null && model != '') {
        this.options.carTypeOptions = [];
        this.form.type = null;
        this.modelTypeData.forEach((el) => {
          if (el.car_model === model && el.brand_id === brand) {
            this.options.carTypeOptions.push(el);
          }
        });
      }
    },
    childHanel(val) {
      this.form.tbox_num = val.tbox_num;
      // this.noform = val
      // this.$refs.form.clearValidate('vin')
    },

    getHardwareCode(code) {
      //获取
      const newServiceType = [...this.serviceList];
      const index = newServiceType
        .map((item) => item.id)
        .indexOf(this.serviceTypeId);
      if (index !== -1) {
        newServiceType[index].code = code;
      }
      this.serviceList = newServiceType;
    },

    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          let hardwareList = [];
          this.serviceList.forEach((item) => {
            if (item.code !== '') {
              hardwareList.push({
                serviceTypeId: item.id,
                code: item.code,
              });
            }
          });
          this.form.hardwareList = hardwareList;
          addCarInform(this.form)
            .then(() => {
              this.$message.success('保存成功!');
              this.$router.back(-1);
              this.disabled = false;
            })
            .catch(() => {
              this.disabled = false;
            });
        } else {
          return false;
        }
      });
    },
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        this.form.photo = res.data.src;
      }
    },
    //车辆型号选择后展示车辆图片信息
    typeChange() {
      let chooseType = this.form.type;
      // console.log(this.options)
      this.options.type.forEach((el) => {
        if (el.id == chooseType) {
          this.form.typeImg = el.type_img;
          this.form.e_instruction = el.instruction_url;
          this.form.e_instructionName = el.instruction_name;
        }
      });
    },
    //所属公司选中事件
    selectChange() {
      this.clearRentDataOptions();
      this.initRentCompanyData(this.form.belong_company);
    },
    //获取所属公司数据
    initCompanyData() {
      selectCompanyData().then((res) => {
        if (res.code == 0) {
          this.receiveCompData = res.data;
          this.initBelongCompanyData();
        }
      });
    },
    //获取租赁公司数据
    initRentCompanyData(compId) {
      this.receiveCompData.forEach((el) => {
        if (el.parent_comp_id == compId) {
          this.options.rentCompDataOptions.push(el);
        }
      });
    },
    //获取所属公司数据
    initBelongCompanyData() {
      this.receiveCompData.forEach((el) => {
        this.options.belongCompDataOptions.push(el);
      });
      const belongCompany = JSON.parse(localStorage.user).belongCompany;
      this.form.belong_company = Number(belongCompany) || '';
      if (this.form.belong_company) {
        this.getDataSelectXing();
        this.getCarTypeData();
      }
      //this.initRentCompanyData(this.form.belong_company)
    },
    //清理租赁公司
    clearRentDataOptions() {
      this.form.rent_company = null;
      this.options.rentCompDataOptions = [];
    },
  },
};
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    /deep/.el-date-editor.el-input {
      width: 100%;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.step {
  font-size: 24px;
  font-weight: 600;
  margin: 10px 0 10px 80px;
}
</style>
